import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FormValidation } from '@shared/interfaces/form-validation';
import { OrderByPipe } from '@shared/pipes/order-by.pipe';

@Component({
    selector: 'sas-select',
    standalone: true,
    imports: [CommonModule, TranslateModule, FormsModule],
    providers: [NgModel],
    templateUrl: './sas-select.component.html',
    styleUrl: './sas-select.component.scss'
})
export class SasSelectComponent {
    @Input() name!: string;
    @Input() sasId?: string;
    @Input() label!: string;
    @Input() defaultText?: string;
    @Input() hideLabel?: string;
    @Input() sasHelptext?: string;
    @Input() sasDisabled?: boolean;
    @Input() sasClass?: string;
    @Input() maxLength?: number;
    @Input() sasOptions!: Array<any>;
    @Input() model!: any;
    @Input() validation?: FormValidation;
    @Input() customSort?: string;
    @Output() sasOnSelect = new EventEmitter<any>();
    @Output() modelChange = new EventEmitter<any>();

    items: Array<any> = [];
    disabled: boolean = false;
    instanceId: string = '';
    labelId: string = '';
    helpText: string;
    ariaRequired: boolean = false;
    private random = Math.random().toString(36).substring(2);

    constructor(private orderByPipe: OrderByPipe) {
        this.helpText = this.sasHelptext ?? '';
        this.sasId = this.sasId === undefined ? '' : this.sasId;
    }

    ngOnChanges(changes: any) {
        if (changes.sasOptions) {
            this.items = (this.customSort === undefined || this.customSort === 'false')
                ? this.items = this.sortItems()
                : this.items = Object.assign({}, this.sasOptions);
        }
    }

    ngOnInit() {
        this.instanceId = this.sasId + this.random;
        this.sasHelptext = this.sasHelptext ?? '';
        this.name = this.name ?? '';
        this.name = this.name.concat(this.random);

        if (this.sasDisabled !== undefined && this.sasDisabled === true) {
            this.disabled = true;
        }
        this.labelId = this.sasId || this.name || this.label;
        if (this.labelId !== undefined && this.labelId.length) {
            this.labelId = `${this.labelId.replace(/\s/g, "")}Label`;
        }
        if (this.validation !== undefined && this.validation.required !== undefined) {
            this.ariaRequired = this.validation.required;
        }
    }

    onSelect() {
        this.modelChange.emit(this.model);
        if (this.sasOnSelect !== undefined) {
            this.sasOnSelect.emit({
                'value': this.model,
                'selectId': this.sasId,
                'selectName': this.name
            })
        }
    }

    sortItems(): Array<any> {
        return this.orderByPipe.transform(this.sasOptions, 'name');
    }
}
